module.exports = __webpack_public_path__ + "static/media/pirate.09a9ed60.png";